module.exports='<!-- @author Sergey Kuzhavskiy <Praffesor>--><gccs-note-list client-id="managerClientNotesCtrl.clientId" editable="false"></gccs-note-list>';